import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Typography, TextField, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Stack, Divider } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from 'react-i18next';
import imagen1 from "../../assets/guias_implementacion/IconosExterior/Group-14.png"
import imagen2 from "../../assets/guias_implementacion/IconosExterior/Group.png"
import imagen3 from "../../assets/guias_implementacion/IconosExterior/Group-1.png"
import imagen4 from "../../assets/guias_implementacion/IconosExterior/Group-2.png"
import imagen5 from "../../assets/guias_implementacion/IconosExterior/Group-15.png"
import imagen6 from "../../assets/guias_implementacion/IconosExterior/Group-3.png"
import imagen7 from "../../assets/guias_implementacion/IconosExterior/Group-7.png"
import imagen8 from "../../assets/guias_implementacion/IconosExterior/Group-4.png"
import imagen9 from "../../assets/guias_implementacion/IconosExterior/Group-5.png"
import imagen10 from "../../assets/guias_implementacion/IconosExterior/Capa_1.png"
import imagen11 from "../../assets/guias_implementacion/IconosExterior/Group-12.png"
import imagen12 from "../../assets/guias_implementacion/IconosExterior/Group-13.png"
import imagen13 from "../../assets/guias_implementacion/IconosExterior/Group-6.png"
import imagen14 from "../../assets/guias_implementacion/IconosExterior/Group-8.png"
import imagen15 from "../../assets/guias_implementacion/IconosExterior/Group-10.png"

const plataformas = [
    { nombre: "HTML/CSS", icono: imagen1, ruta: "/dashboard/guia-htmlcss" },
    { nombre: "Wordpress", icono: imagen2, ruta: "/dashboard/guia-wordpress" },
    { nombre: "Shopify", icono: imagen3, ruta: "/dashboard/guia-shopify" },
    { nombre: "SquareSpace", icono: imagen4, ruta: "/dashboard/guia-squarespace" },
    { nombre: "Webflow", icono: imagen5, ruta: "/dashboard/guia-webflow" },
    { nombre: "Wix", icono: imagen6, ruta: "/dashboard/guia-wix" },
    { nombre: "Magento", icono: imagen7, ruta: "/dashboard/guia-magento" },
    { nombre: "Joomla", icono: imagen8, ruta: "/dashboard/guia-joomla" },
    { nombre: "Drupal", icono: imagen9, ruta: "/dashboard/guia-drupal" },
    { nombre: "OpenCart", icono: imagen10, ruta: "/dashboard/guia-opencart" },
    { nombre: "HubSpot", icono: imagen11, ruta: "/dashboard/guia-hubspot" },
    { nombre: "Moodle", icono: imagen12, ruta: "/dashboard/guia-moodle" },
    { nombre: "PrestaShop", icono: imagen13, ruta: "/dashboard/guia-prestashop" },
    { nombre: "Weebly", icono: imagen14, ruta: "/dashboard/guia-weebly" },
    { nombre: "Duda", icono: imagen15, ruta: "/dashboard/guia-duda" },
];

export default function PlataformaSelector({ hideDetection = false }) {
    const { t } = useTranslation();
    const [busqueda, setBusqueda] = useState("");
    const navigate = useNavigate();

    const filtradas = plataformas.filter(p =>
        p.nombre.toLowerCase().includes(busqueda.toLowerCase())
    );

    return (
        <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent sx={{ padding: 0, "&:last-child": { paddingBottom: 0 } }}>
                {/* ── Header ── */}
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        backgroundColor: "#0F52BD",
                        color: "white",
                        padding: 1,
                        pl: 3,
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px"
                    }}
                >
                    <Typography variant="h6" sx={{ mb: { xs: 1, sm: 0 } }}>
                        {t("Selecciona tu plataforma o CMS")}
                    </Typography>

                    <TextField
                        variant="outlined"
                        placeholder={t("Busca tu plataforma...")}
                        size="small"
                        sx={{
                            backgroundColor: "white",
                            borderRadius: 1,
                            minWidth: { xs: 200, sm: 250 },
                            "& .MuiInputBase-input::placeholder": {
                                color: "#595959",
                                opacity: 1
                            }
                        }}
                        InputProps={{
                            startAdornment: <SearchIcon color="#595959" />
                        }}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                </Stack>

                <Divider />

                {/* ── Platform list ── */}
                <List sx={{ maxHeight: 250, overflowY: "auto", paddingY: 1 }}>
                    {filtradas.map((p, index) => (
                        <ListItem
                            key={index}
                            divider
                            sx={{
                                "&:last-child": { marginBottom: 0, paddingBottom: 0, borderBottom: "none" },
                            }}
                        >
                            <ListItemAvatar>
                                <Avatar
                                    src={p.icono}
                                    alt={`Logo ${p.nombre}`}
                                    variant="square"
                                    sx={{ borderRadius: 2, width: 40, height: 40 }}
                                />
                            </ListItemAvatar>
                            <ListItemText primary={p.nombre} />
                            <Button
                                variant="outlined"
                                sx={{ color: "#0F52BD", borderColor: "blue", textTransform: "capitalize" }}
                                onClick={() => navigate(p.ruta)}
                            >
                                {t("Ver guía")}
                            </Button>
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    );
}
